/**
 * Variant combination guard
 * ----------------------------------------------------------------------------------------------------
 * Some products have option combinations that don't exist as a variant (for example "Brown" glasses that
 * are only made in "Frame B", so "Brown / Frame A" has no variant). When a shopper changes an earlier
 * option, the later option they had selected can become impossible, which leaves the theme rendering the
 * default gallery images with no real variant selected.
 *
 * This runs in the capture phase, before the theme's own change handler, and re-flows every option after
 * the one the shopper just changed to a value that keeps the combination real. It reads the list of real
 * combinations that variant-picker.liquid prints as <script data-variant-combinations>. Existence is
 * structural only: an out-of-stock variant still counts as real, so sold-out options stay selectable.
 */
(function () {
  if (window.__tmrwVariantComboGuard) return;
  window.__tmrwVariantComboGuard = true;

  // Can a real combination still be reached with `sel` fixed for positions 0..upto?
  function prefixReachable(existing, sel, upto) {
    return existing.some(function (combo) {
      for (var i = 0; i <= upto; i++) {
        if (sel[i] != null && combo[i] !== sel[i]) return false;
      }
      return true;
    });
  }

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches('input[data-option-position]')) return;

      var picker = input.closest('variant-picker');
      var form = input.form;
      if (!picker || !form) return;

      var matrixEl = picker.querySelector('script[data-variant-combinations]');
      if (!matrixEl) return;

      var existing;
      try {
        existing = JSON.parse(matrixEl.textContent);
      } catch (e) {
        return;
      }
      if (!Array.isArray(existing) || existing.length === 0) return;

      // Group the option inputs by their 1-based position, keeping document (display) order within a group.
      var groups = {};
      var positions = [];
      Array.prototype.forEach.call(form.elements, function (el) {
        if (el.matches && el.matches('input[data-option-position]')) {
          var p = parseInt(el.getAttribute('data-option-position'), 10);
          if (!groups[p]) {
            groups[p] = [];
            positions.push(p);
          }
          groups[p].push(el);
        }
      });
      positions.sort(function (a, b) {
        return a - b;
      });

      // Current selection as an array indexed by option order (0-based).
      var sel = positions.map(function (p) {
        var checked = groups[p].filter(function (el) {
          return el.checked;
        })[0];
        return checked ? checked.value : null;
      });

      var changedIndex = positions.indexOf(parseInt(input.getAttribute('data-option-position'), 10));
      if (changedIndex === -1) return;

      // Re-flow each option after the one just changed so the whole combination stays real.
      for (var i = changedIndex + 1; i < positions.length; i++) {
        if (prefixReachable(existing, sel, i)) continue; // current value still works

        var inputs = groups[positions[i]];
        for (var k = 0; k < inputs.length; k++) {
          var trial = sel.slice();
          trial[i] = inputs[k].value;
          if (prefixReachable(existing, trial, i)) {
            sel[i] = inputs[k].value;
            inputs[k].checked = true; // radio group auto-unchecks siblings; does not fire another change
            break;
          }
        }
      }
      // The theme's own (bubble-phase) handler runs next and reads the now-corrected inputs.
    },
    true // capture: run before the theme's delegated change handler
  );
})();
